import { render, staticRenderFns } from "./ChooseMerchantType.vue?vue&type=template&id=23375419&scoped=true"
import script from "./ChooseMerchantType.vue?vue&type=script&lang=js"
export * from "./ChooseMerchantType.vue?vue&type=script&lang=js"
import style0 from "./ChooseMerchantType.vue?vue&type=style&index=0&id=23375419&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23375419",
  null
  
)

export default component.exports